import { render } from "./Template.vue?vue&type=template&id=e0fc735a&scoped=true"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e0fc735a"

export default script